import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pseudo-classes"
    }}>{`Pseudo-classes`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "active.md"
        }}>{`active`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "checked.md"
        }}>{`checked`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "defined.md"
        }}>{`defined`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "disabled.md"
        }}>{`disabled`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "empty.md"
        }}>{`empty`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enabled.md"
        }}>{`enabled`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "first-child.md"
        }}>{`first-child`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "focus.md"
        }}>{`focus`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "hover.md"
        }}>{`hover`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "last-child.md"
        }}>{`last-child`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "nth-child.md"
        }}>{`nth-child`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "nth-last-child.md"
        }}>{`nth-last-child`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "nth-last-of-type.md"
        }}>{`nth-last-of-type`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "nth-of-type.md"
        }}>{`nth-of-type`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "only-child.md"
        }}>{`only-child`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "root.md"
        }}>{`root`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      